import { Plus, Trash2 } from "lucide-react";
import { uid } from "../../lib/uid";
import { focusNextOnEnter } from "../dataentry/entryHelpers";
import AmountInput from "../AmountInput";

const inp = "w-full px-2 py-1.5 text-sm border border-slate-300 rounded-md bg-white";
export const newExtraRow = () => ({ _k: uid(), budget_item_id: "", amount: "", desc: "" });

export function CostItemsTable({ expenseItems, vals, setVal, extras, setExtras }) {
  const setExtra = (k, patch) => setExtras(extras.map((r) => (r._k === k ? { ...r, ...patch } : r)));
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid="pcost-items-table" onKeyDown={focusNextOnEnter} title="Enter: Tutar → Açıklama → sonraki kalem · Ctrl+Enter: Maliyet Oluştur">
      <table className="w-full tbl">
        <thead className="bg-slate-50">
          <tr>
            <th className="px-3 py-2 text-left text-xs uppercase tracking-wider text-slate-600 font-semibold">Gider Kalemi</th>
            <th className="px-3 py-2 text-right text-xs uppercase tracking-wider text-slate-600 font-semibold w-44">Tutar</th>
            <th className="px-3 py-2 text-left text-xs uppercase tracking-wider text-slate-600 font-semibold w-72">Açıklama</th>
            <th className="w-8" />
          </tr>
        </thead>
        <tbody>
          {expenseItems.map((b, i) => (
            <tr key={b.id} className="border-t border-slate-100" data-testid={`pcost-row-${b.id}`}>
              <td className="px-3 py-1.5 text-sm font-medium text-slate-800" data-testid={`pcost-row-name-${i}`}>{b.name}</td>
              <td className="px-2 py-1">
                <AmountInput value={vals[b.id]?.amount ?? ""} onChange={(v) => setVal(b.id, { amount: v })} placeholder="0,00"
                  testid={`pcost-row-amount-${i}`} className={`${inp} text-right font-mono`} />
              </td>
              <td className="px-2 py-1">
                <input value={vals[b.id]?.desc ?? ""} onChange={(e) => setVal(b.id, { desc: e.target.value })} placeholder="Açıklama (opsiyonel)"
                  data-testid={`pcost-row-desc-${i}`} className={inp} />
              </td>
              <td />
            </tr>
          ))}
          {extras.map((r, i) => (
            <tr key={r._k} className="border-t border-amber-100 bg-amber-50/40" data-testid={`pcost-extra-row-${i}`}>
              <td className="px-2 py-1">
                <select value={r.budget_item_id} onChange={(e) => setExtra(r._k, { budget_item_id: e.target.value })} data-testid={`pcost-extra-item-${i}`} className={inp}>
                  <option value="">— Gider kalemi seçin —</option>
                  {expenseItems.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                </select>
              </td>
              <td className="px-2 py-1">
                <AmountInput value={r.amount} onChange={(v) => setExtra(r._k, { amount: v })} placeholder="0,00"
                  testid={`pcost-extra-amount-${i}`} className={`${inp} text-right font-mono`} />
              </td>
              <td className="px-2 py-1">
                <input value={r.desc} onChange={(e) => setExtra(r._k, { desc: e.target.value })} placeholder="Açıklama (opsiyonel)" data-testid={`pcost-extra-desc-${i}`} className={inp} />
              </td>
              <td className="px-1 text-center">
                <button type="button" onClick={() => setExtras(extras.filter((x) => x._k !== r._k))} className="text-red-600 hover:text-red-800" data-testid={`pcost-extra-del-${i}`}><Trash2 className="w-4 h-4" /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="px-3 py-2 border-t border-slate-200 bg-slate-50">
        <button type="button" onClick={() => setExtras([...extras, newExtraRow()])} data-testid="pcost-add-row"
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md text-xs font-semibold border border-slate-300 bg-white hover:bg-slate-100">
          <Plus className="w-3.5 h-3.5" /> Satır Ekle
        </button>
        <span className="ml-2 text-[11px] text-slate-500">Eklenen satırda gider kalemi PROJE GİDERLERİ listesinden seçilir.</span>
      </div>
    </div>
  );
}
